import { useEffect, ReactNode } from "react";
import { buildEmbedUrl } from "@/lib/embedUrl";

interface ExamplePageTemplateProps {
  backgroundColor?: string;
  header: ReactNode;
  hero?: ReactNode;
  children: ReactNode;
  chatButtonColor?: string;
  chatButtonIcon?: string;
  embedUrl?: string;
  additionalHooks?: () => void;
}

const ExamplePageTemplate = ({
  backgroundColor = "white",
  header,
  hero,
  children,
  chatButtonColor = "blue-600",
  chatButtonIcon = "💬",
  embedUrl = buildEmbedUrl(window.location.origin, "business-onboarding"),
  additionalHooks,
}: ExamplePageTemplateProps) => {
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';

    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
    };
  }, []);

  // Execute any additional hooks passed from the example page
  if (additionalHooks) {
    additionalHooks();
  }

  return (
    <div className={`min-h-screen bg-${backgroundColor}`}>
      {/* Header */}
      {header}

      {/* Hero Section */}
      {hero}

      {/* Main Content */}
      {children}

      {/* Fixed Embed Widget */}
      <div className="fixed bottom-6 left-6 z-50">
        <div className="bg-white rounded-lg shadow-2xl overflow-hidden">
          <iframe
            src={embedUrl}
            width="380"
            height="600"
            frameBorder="0"
            allow="microphone"
            style={{
              border: 'none',
            }}
          />
        </div>
      </div>

      {/* Floating Chat Button Indicator */}
      <div className="fixed bottom-6 right-6 z-40">
        <div className={`w-16 h-16 bg-${chatButtonColor} rounded-full flex items-center justify-center shadow-lg animate-pulse`}>
          <span className="text-white text-2xl">{chatButtonIcon}</span>
        </div>
      </div>
    </div>
  );
};

export default ExamplePageTemplate;